const gridStyle = Object.freeze({
  gutterWidth: 4, // (in rems)

  // rule
  ruleWidth: 1, // (in pixels)
  ruleColor: [ 'neutral', '-5', ],
});

export default gridStyle;
